export default "__VITE_ASSET__CxsZI6Tj__"